
export class SharingService {
  static async shareViaEmail(url: string, subject?: string, body?: string) {
    const emailSubject = encodeURIComponent(subject || "Check out this article");
    const emailBody = encodeURIComponent(body || `I thought you might be interested in this article: ${url}`);
    window.open(`mailto:?subject=${emailSubject}&body=${emailBody}`);
    return true;
  }

  static async shareViaBluesky(url: string, text?: string) {
    const shareText = encodeURIComponent(text || "Check out this article: " + url);
    window.open(`https://bsky.app/intent/post?text=${shareText}`);
    return true;
  }

  static async shareViaTwitter(url: string, text?: string) {
    const shareText = encodeURIComponent(text || "Check out this article: " + url);
    window.open(`https://twitter.com/intent/tweet?text=${shareText}`);
    return true;
  }

  static async shareViaFacebook(url: string) {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
    return true;
  }

  static async shareViaNavigator(title: string, url: string, text?: string) {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: text || title,
          url
        });
        return true;
      } catch (error) {
        if ((error as Error).name !== 'AbortError') {
          console.error('Error sharing via navigator:', error);
        }
      }
    }
    return false;
  }

  static async copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      return false;
    }
  }
}
